import { useMaskito } from "@maskito/react";
import type { ComponentProps } from "react";
import TextField from "./text-field";
import type { RefCallBack } from "react-hook-form";
import { Badge } from "@elaniintc/goes-design-system";
import { cn } from "@/utils/theme";

interface Props extends ComponentProps<typeof TextField> {
  formRef?: RefCallBack;
}

const PhoneField = ({ formRef, ...props }: Props) => {
  const phoneMask = useMaskito({
    options: {
      mask: [/\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/],
    },
  });

  return (
    <TextField
      {...props}
      value={props.value}
      onChange={props.onChange}
      ref={(el) => {
        formRef?.(el);
        phoneMask(el);
      }}
      leadingIcon={<Badge className="h-6 text-sm">+503</Badge>}
      className={cn(`pl-[70px]`, props.className)}
    />
  );
};

export default PhoneField;
